export class CostCode {
    id = null;
    costCodeNumber = '';
    description = '';
    isPrevailingWage = false;
}


